import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../../services/index';
import { Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Upload, Modal,message    } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';





const buttonWidth = 70;
const { TextArea } = Input;
function callback(key) {
  console.log(key);
}


function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

function getBase64_(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

function beforeUpload(file) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!');
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!');
  }
  return isJpgOrPng && isLt2M;
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			previewVisible: false,
			previewImage: '',
			previewTitle: '',
			imageUrl: '',
			fileList: [],
			route_list: [],
			stop_list: [],
			stop_id: [],
			pickup: [],
			drop: [],
			values: [1],
			loading: false,
			name: '',
			mobile: '',
			licence: '',
			route_id: '',
			loading: false,
  		    iconLoading: false,
		}
		
		this.change_route = this.change_route.bind(this);
		this.change_stop = this.change_stop.bind(this);
		this.change_pickup = this.change_pickup.bind(this);
		this.change_drop = this.change_drop.bind(this);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id']});
		
		}
		this.checkData();
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var app = {school_id : school_id,user_id:user_id}
			getData('Transport/new_route_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							route_list: result['data'],
						});
					}else{
						this.setState({
							route_list: [],
						});
					}
				}
			});	
			getData('Transport/stop_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							stop_list: result['data'],
						});
					}else{
						this.setState({
							stop_list: [],
						});
					}
				}
			});	
			
				
			
	}
  }
	
	
	handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
		this.setState({ loading: true });
		
		if(this.state.route_id === ''){
			message.config({ top: 150});
			message.error('Please Select Route',2);
			this.setState({ loading: false });
		}else{
			
			const lenght = this.state.values.length;
			var pickup = [];
				for (var i = 0; i < lenght; i++) {
				 pickup[i]= document.getElementById('pickup_'+i).value; 
			}
			
			var drop = [];
				for (var i = 0; i < lenght; i++) {
				 drop[i]= document.getElementById('drop_'+i).value; 
			}
			
			var stop = [];
				for (var i = 0; i < lenght; i++) {
				 stop[i]= document.getElementById('stop_'+i).value; 
			}
			
			var app = {
				user_id : this.state.user_id,
				school_id : this.state.school_id,
				route_id : this.state.route_id,
				stop_id : stop,
				pickup_sequence : pickup,
				drop_sequence : drop,
			}
			
			getData('Transport/add_manage_route',app).then((result) => {
				if(result.status==400){
					message.config({ top: 150});
					message.error('Please Insert All Fields',2);
					this.setState({ loading: false });
				}
				else if(result.status==200){
					message.config({ top: 150});
					message.success('Compose Route Added',2);
					this.setState({ loading: false });
					this.setState({comment_text:''});
					window.location.href = '/transport-setup/manage-route/compose-route';
				}
				else{
					this.setState({ loading: false });
				}
			});
		}
		
	 }else{
		message.error('Please Login',2);	
		this.setState({ loading: false });
	  }

	}
	
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
	
  };
  
  change_route(event){
         this.setState({route_id: event});
     }
	 
	change_stop(i,event){
		this.setState({
		  stop_id: [...this.state.stop_id, event]
		})
		document.getElementById('stop_'+i).value = event;
     } 
	 
	change_pickup = (i,e) => {
		//alert(e.target.value);
		this.setState({ pickup: [...this.state.pickup, e.target.value] });
		 document.getElementById('pickup_'+i).value = e.target.value;
		 
	};
	
	change_drop = (i,e) => {
		this.setState({ drop: [...this.state.drop, e.target.value] });
		document.getElementById('drop_'+i).value = e.target.value;
	};
  
  
  handleChange = ({ fileList }) => this.setState({ fileList });
  
	createUI(){
		const lenght = this.state.values.length;
		 return this.state.values.map((el, i) => 
			
			 <div class={`col m12 mb-10 no-padd ${i}`} key={i}>
						<div class="bb d-inline-block w-100">
							 <div class="row ml-0 card-content iq-card">
										<div class="col-md-3 mb-0">
											<label>Stop Name</label>
											<Select name={`category_id_${i}`} id={`category_id_${i}`} onChange={this.change_stop.bind(this,i)} required>
													{this.state.stop_list.map((list) => (
													<Select.Option value={list.id}>{list.name}</Select.Option>
													))}
												
											</Select>
											<input type="hidden" id={`stop_${i}`} />
										</div>
										
										
										<div class="col-md-3 mb-10">
											<label>Pickup Sequence</label>
											<input type="text" name={`pickup_${i}`} onChange={this.change_pickup.bind(this,i)}    required/>
											<input type="hidden" id={`pickup_${i}`} />
										</div>
										<div class="col-md-3 mb-10">
											<label>Drop Sequence</label>
											<input type="text" name={`drop_${i}`}  onChange={this.change_drop.bind(this,i)}   required/>
											<input type="hidden" id={`drop_${i}`} />
										</div>
									
							 
							  {(() => {
								  
									if (lenght > 1) {
									return (
										
										  <div class="col-md-3 center mt-20 mob-mt-0">
												<Button className="ant-btn btn  btn-primary mr-2" onClick={this.removeClick.bind(this, i)}>Remove</Button>
											</div>
										
										)
									}
								})()}
								</div>
							</div>	
										
			 </div>          
		 )
	  }
  
	addClick(){
		this.setState(prevState => ({ values: [...prevState.values, '']}))
	}
	removeClick(i){
		 let values = [...this.state.values];
		 values.splice(i,1);
		 this.setState({ values });
	  }

	render()

	{
	
	const { previewVisible, previewImage, fileList, previewTitle } = this.state;
     const uploadButton = (
      <div>
        <div className="ant-upload-text">Upload</div>
      </div>
    );
	const uploadButton1 = (
		  <div>
			{this.state.loading ? <LoadingOutlined /> : <PlusOutlined />}
			<div className="ant-upload-text">Upload Profile</div>
		  </div>
		);
		const { imageUrl } = this.state;
					
		return (
			<div class="mobile_view">
				<div class="row bred">
					<div class="col-md-12">
						<div class="card">
							<div class="card-body">
								<h4 class="page-title"> 
									<i class="mdi mdi-apple-keyboard-command title_icon"></i>Add Compose Route
									<div class="breadcrumb-wrapper">
										<ol class="breadcrumb">
											<li class="breadcrumb-item">
												<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
												<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
												</a>
											</li>
											<li class="breadcrumb-item"> <a href={`${process.env.PUBLIC_URL}/transport-setup/manage-route/compose-route`} class="router-link-active" target="_self">Manage Route - Compose Route </a></li>
											<li class="breadcrumb-item"> Add Compose Route </li>
										</ol>
									</div>
								</h4>
							</div>
						</div>
					</div>
				</div>
			
				<div id="main" class="bg-off">
					<div class="row">
					  <div class="col s12 m12 ex-padd">   
						<div class="view-Profile child-profile view-Profile-mobile">
						   <div class="col-md-12 mb-20 mt-10 card-content iq-card">
							  <section class="invoice-list-wrapper section food ">
								<div class="children mb-20 iq-card2 flow-root form-group">
								    <div class="row">
										<div class="col-md-6 mb-10">
											<label>Route Name *</label>
											<Select onChange={this.change_route}>
												{this.state.route_list.map((list) => (
														<Select.Option value={list.id}>{list.name}</Select.Option>
												))}
											</Select>
										</div>	
										<div class="col-md-12 pl-0 mt-0">
										{this.createUI()} 
											<div class="col-md-12 mb-10 pb-20 ">
												<Button className="ant-btn btn  btn-primary mr-2" onClick={this.addClick.bind(this)}>Add Stop</Button>
											</div>
										</div>
									</div>	
								</div> 
								<div class="col-md-12 meal mt-20 mb-20 pt-20 bt center">
									<Button className="ant-btn btn  btn-primary mr-2" onClick={this.handleSubmit} loading={this.state.loading}>Save</Button>
								</div>
							  </section>
						   </div>
						<div class="content-overlay"></div>
						</div>
					  </div>
					</div>
				</div>
            </div>
		) 
	} 
}
export default Index;
